:host {
  @apply block;
}

::slotted([slot=pagination]) {
  @apply w-full flex justify-center mt-[35px];
}
